import Cookies from 'js-cookie';

export default class RibbonController {
    constructor() {
        this.ribbon = null;

        if (document.getElementById('ribbon')) {
            this.ribbon = document.getElementById('ribbon');

            this.init();
        }
    }

    init() {
        // Decide wether it needs to be shown or not
        // Check if user cleared the ribbon already
        const cookie = Cookies.get(`ribbon_${this.ribbon.dataset.id}`);

        if (cookie) {
            const cookieDate = new Date(cookie);
            const updatedDate = new Date(this.ribbon.dataset.updated);

            if (cookieDate < updatedDate) {
                Cookies.remove(`ribbon_${this.ribbon.dataset.id}`);
                this.setActive();
            }
        } else {
            this.setActive();
        }

        this.setEventListeners();
    }

    setEventListeners() {
        window.app.registerResizeEvent(this.resize.bind(this));

        this.ribbon.querySelector('.close').addEventListener('click', e => {
            e.preventDefault();
            this.setInactive();
        });
    }

    isActive() {
        return this.ribbon.classList.contains('active');
    }

    setActive() {
        this.resize();
        this.ribbon.classList.add('active');
        document.documentElement.classList.add('ribbonActive');
        
        // Accessibility
        this.ribbon.setAttribute('aria-expanded', 'true');
        this.ribbon.querySelector('.close').setAttribute('tabindex', '0');
    }

    setInactive() {
        this.ribbon.classList.remove('active');
        document.documentElement.classList.remove('ribbonActive');
        
        // Accessibility
        this.ribbon.setAttribute('aria-expanded', 'false');
        this.ribbon.querySelector('.close').setAttribute('tabindex', '-1');

        // Add to the cookie
        let cookieSettings = {};
        if (!this.ribbon.dataset.session || this.ribbon.dataset.session) {
            cookieSettings.expires = 14;
        }

        Cookies.set(`ribbon_${this.ribbon.dataset.id}`, (new Date).toISOString(), cookieSettings);
    }

    resize() {
        document.documentElement.style.setProperty('--ribbonHeight', `${this.ribbon.clientHeight}px`);
    }
}